<template>
  
    <div class="vertical-menu" style="background-color: #031D4C;">

        <div data-simplebar class="h-100" style="background-color: #031D4C;">

            <!--- Sidemenu -->
            <div id="sidebar-menu" style="background-color: #031D4C;">
                <!-- Left Menu Start -->
                <ul class="metismenu list-unstyled" id="side-menu" style="background-color: #031D4C;">
                    <li class="menu-title" style="text-align: left;">Menu</li>

                    <li style="background-color: #031D4C;text-align: left;">
                        <a href="https://sareci.seguridadeninspeccion.com/inicio" class="waves-effect" style="background-color: #031D4C;">
                            <i class="mdi mdi-home-variant-outline"></i>
                            <!--<span
                                class="badge rounded-pill bg-primary float-end">3</span>-->
                                <router-link  to="/inicio" ><span>Dashboard</span></router-link> 
                        </a>
                    </li>
                    
                    <li style="text-align: left;">
    <a href="javascript:void(0);" class="has-arrow waves-effect">
        <i class="mdi mdi-email-outline"></i>
        <router-link  to="" ><span>Aranceles</span></router-link>
    </a>

    <ul class="sub-menu" aria-expanded="false">

        <li style="text-align: left;">
            <router-link to="/gd">
                <span>Generación distribuida</span>
            </router-link>
        </li>

        <li style="text-align: left;">
            <router-link to="/codistribucion">
                <span>Centros de carga de distribución</span>
            </router-link>
        </li>

        <li style="text-align: left;">
            <router-link to="/cotransmision">
                <span>Centros de carga de transmisión</span>
            </router-link>
        </li>

        <li style="text-align: left;">
            <router-link to="/cidistribucion">
                <span>Centrales eléctricas de distribución</span>
            </router-link>
        </li>

        <li style="text-align: left;">
            <router-link to="/citransmision">
                <span>Centrales eléctricas de transmisión</span>
            </router-link>
        </li>

    </ul>
</li>
                    <li style="text-align: left;">
                      <a  href="https://sareci.seguridadeninspeccion.com/cotizacion" class=" waves-effect" style="background-color: #031D4C;">
                        <i class="mdi mdi-account-circle"></i>
                        <router-link  to="/cotizacion" ><span>Cotizacion</span></router-link> 
                          
                      </a>
                    </li>
                    
                    <li style="text-align: left;">
                      <a href="https://sareci.seguridadeninspeccion.com/detallesolicitud" class=" waves-effect" style="background-color: #031D4C;">
                          <i class="mdi mdi-clipboard-check"></i>
                          <router-link  to="/detallesolicitud" ><span>Solicitudes</span></router-link>
                      </a>
                    </li>
                    <li style="text-align: left;">
                      <a href="https://sareci.seguridadeninspeccion.com/detalleinspeccion" class=" waves-effect" style="background-color: #031D4C;">
                          <i class="mdi mdi-account-search"></i>
                          <router-link  to="/detalleinspeccion" ><span>Inspecciones</span></router-link>
                      </a>
                    </li>
                    <li style="text-align: left;">
                      <a href="https://sareci.seguridadeninspeccion.com/usuarios" class=" waves-effect" style="background-color: #031D4C;">
                        <i class="mdi mdi-account-circle"></i>
                        <router-link  to="/usuarios" ><span>Usuarios</span></router-link> 
                          
                      </a>
                    </li>
                    <li style="text-align: left;">
                      <a href="https://sareci.seguridadeninspeccion.com/roles" class=" waves-effect" style="background-color: #031D4C;">
                        <i class="mdi mdi-account-key"></i>
                        <router-link  to="/roles" ><span>Roles</span></router-link> 
                          
                      </a>
                    </li>
                </ul>
            </div>
            <!-- Sidebar -->
        </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "MenuComponent",
    mounted() {
      this.initializeMenu();
    },
    methods: {
      initializeMenu() {
        // Copia aquí el código de inicialización del menú desde app.js
        // Modifica las partes que manipulan el DOM directamente para que se ejecuten después de que Vue haya montado el componente
        (function(n) {
          "use strict";
  
          function s() {
            for (var e = document.getElementById("topnav-menu-content").getElementsByTagName("a"),
                t = 0, n = e.length; t < n; t++) {
              if ("nav-item dropdown active" === e[t].parentElement.getAttribute("class")) {
                e[t].parentElement.classList.remove("active");
                e[t].nextElementSibling.classList.remove("show");
              }
            }
          }
  
          function t(e) {
            if (n("#light-mode-switch").prop("checked") && "light-mode-switch" === e) {
              n("html").removeAttr("dir");
              n("#dark-mode-switch").prop("checked", !1);
              n("#rtl-mode-switch").prop("checked", !1);
              n("#bootstrap-style").attr("href", "assets/css/bootstrap.min.css");
              n("#app-style").attr("href", "assets/css/app.min.css");
              sessionStorage.setItem("is_visited", "light-mode-switch");
            } else if (n("#dark-mode-switch").prop("checked") && "dark-mode-switch" === e) {
              n("html").removeAttr("dir");
              n("#light-mode-switch").prop("checked", !1);
              n("#rtl-mode-switch").prop("checked", !1);
              n("#bootstrap-style").attr("href", "assets/css/bootstrap-dark.min.css");
              n("#app-style").attr("href", "assets/css/app-dark.min.css");
              sessionStorage.setItem("is_visited", "dark-mode-switch");
            } else if (n("#rtl-mode-switch").prop("checked") && "rtl-mode-switch" === e) {
              n("#light-mode-switch").prop("checked", !1);
              n("#dark-mode-switch").prop("checked", !1);
              n("#bootstrap-style").attr("href", "assets/css/bootstrap-rtl.min.css");
              n("#app-style").attr("href", "assets/css/app-rtl.min.css");
              n("html").attr("dir", "rtl");
              sessionStorage.setItem("is_visited", "rtl-mode-switch");
            }
          }
  
          function e() {
            if (!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
              n("body").removeClass("fullscreen-enable");
            }
          }
  
          n("#side-menu").metisMenu();
          n("#vertical-menu-btn").on("click", function(e) {
            e.preventDefault();
            n("body").toggleClass("sidebar-enable");
            if (n(window).width() >= 992) {
              n("body").toggleClass("vertical-collpsed");
            } else {
              n("body").removeClass("vertical-collpsed");
            }
          });
          n("body,html").click(function(e) {
            var t = n("#vertical-menu-btn");
            if (!t.is(e.target) && t.has(e.target).length === 0 && !e.target.closest("div.vertical-menu")) {
              n("body").removeClass("sidebar-enable");
            }
          });
          n("#sidebar-menu a").each(function() {
            var e = window.location.href.split(/[?#]/)[0];
            if (this.href == e) {
              n(this).addClass("active");
              n(this).parent().addClass("mm-active");
              n(this).parent().parent().addClass("mm-show");
              n(this).parent().parent().prev().addClass("mm-active");
              n(this).parent().parent().parent().addClass("mm-active");
              n(this).parent().parent().parent().parent().addClass("mm-show");
              n(this).parent().parent().parent().parent().parent().addClass("mm-active");
            }
          });
          n(".navbar-nav a").each(function() {
            var e = window.location.href.split(/[?#]/)[0];
            if (this.href == e) {
              n(this).addClass("active");
              n(this).parent().addClass("active");
              n(this).parent().parent().addClass("active");
              n(this).parent().parent().parent().addClass("active");
              n(this).parent().parent().parent().parent().addClass("active");
              n(this).parent().parent().parent().parent().parent().addClass("active");
            }
          });
          n(document).ready(function() {
            var e;
            if (n("#sidebar-menu").length > 0 && n("#sidebar-menu .mm-active .active").length > 0) {
              e = n("#sidebar-menu .mm-active .active").offset().top;
              if (e > 300) {
                e -= 300;
                n(".vertical-menu .simplebar-content-wrapper").animate({
                  scrollTop: e
                }, "slow");
              }
            }
          });
          n('[data-toggle="fullscreen"]').on("click", function(e) {
            e.preventDefault();
            n("body").toggleClass("fullscreen-enable");
            if (document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement) {
              if (document.cancelFullScreen) {
                document.cancelFullScreen();
              } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
              } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
              }
            } else {
              if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
              } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
              } else if (document.documentElement.webkitRequestFullscreen) {
                document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
              }
            }
          });
          document.addEventListener("fullscreenchange", e);
          document.addEventListener("webkitfullscreenchange", e);
          document.addEventListener("mozfullscreenchange", e);
          n(".right-bar-toggle").on("click", function() {
            n("body").toggleClass("right-bar-enabled");
          });
          n(document).on("click", "body", function(e) {
            if (n(e.target).closest(".right-bar-toggle, .right-bar").length === 0) {
              n("body").removeClass("right-bar-enabled");
            }
          });
          (function() {
            if (document.getElementById("topnav-menu-content")) {
              for (var e = document.getElementById("topnav-menu-content").getElementsByTagName("a"), t = 0, n = e.length; t < n; t++) {
                e[t].onclick = function(e) {
                  if ("#" === e.target.getAttribute("href")) {
                    e.target.parentElement.classList.toggle("active");
                    e.target.nextElementSibling.classList.toggle("show");
                  }
                };
              }
              window.addEventListener("resize", s);
            }
          })();
          [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]')).map(function(e) {
            return new bootstrap.Tooltip(e);
          });
          [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]')).map(function(e) {
            return new bootstrap.Popover(e);
          });
          n(window).on("load", function() {
            n("#status").fadeOut();
            n("#preloader").delay(350).fadeOut("slow");
          });
          if (window.sessionStorage) {
            var a = sessionStorage.getItem("is_visited");
            if (a) {
              n(".right-bar input:checkbox").prop("checked", !1);
              n("#" + a).prop("checked", !0);
              t(a);
            } else {
              sessionStorage.setItem("is_visited", "light-mode-switch");
            }
          }
          n("#light-mode-switch, #dark-mode-switch, #rtl-mode-switch").on("change", function(e) {
            t(e.target.id);
          });
          Waves.init();
        })(jQuery);
      }
    }
  };
  </script>
  <style>
#sidebar-menu ul li a {
    display: flex !important;
    align-items: center !important;
    gap: 10px;
}

#sidebar-menu ul li a i {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    line-height: 1;
    font-size: 18px;
}
#sidebar-menu .sub-menu li a {
    padding-left: 55px !important;
}
</style>